import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, sendPasswordResetEmail } from 'firebase/auth';
import '../pagesCSS/signOnUp.css';
import { GoogleUserAuth } from '../FireBaseConfig/AuthContext';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      if (user) {
        navigate('/');
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/ .test(email);

  const handleForgotPassword = async () => {
    if (!isValidEmail(email)) {
      setError('Please enter a valid email to send reset password link.');
      return;
    }
  
    try {
      await sendPasswordResetEmail(auth, email);
      setError('A password reset link has been sent to your email.');
    } catch (error) {
      console.error("Error sending password reset email: ", error);
      setError('Failed to send password reset email.');
    }
  };

  return (
    <div className="authbody">
      <div className="card">
        <h1 className='h1style1'>Forgot your password</h1>
        <p className='pstyle1 text-align-left'>Please enter the email associated with your account and we'll send you a link to reset your password.</p>

        {error && <p className="error">{error}</p>}
        <input 
          type="text" 
          className="input-field" 
          placeholder="Your email address" 
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button className="continue-btn" onClick={handleForgotPassword}>Send Reset Instructions</button>
        <Link to="/userAuth" className="link-text">Already have an account? Return to Sign In</Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
